
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLicensedApplications"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"licensedApplications"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"rest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"LicensedApplication","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"endpoint"},"value":{"kind":"StringValue","value":"frameworkAPI","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"/configuration/applications","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applicationId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasLicense"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"valid"},"arguments":[],"directives":[]}]}}]}},{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetApplicationConfiguration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"application"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"configuration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"application"},"value":{"kind":"Variable","name":{"kind":"Name","value":"application"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"rest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"Configuration","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"endpoint"},"value":{"kind":"StringValue","value":"frameworkAPI","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"/configuration?application={args.application}","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"configuration"},"arguments":[],"directives":[]}]}}]}},{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCoursesConfiguration"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coursesConfiguration"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"rest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"CoursesConfiguration","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"endpoint"},"value":{"kind":"StringValue","value":"workshopAPI","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"/portfoliooptions","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enableECourses"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enableCampusCourses"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enableDoubleRegistration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pauseRegistration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reportingMonth"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":794}};
    doc.loc.source = {"body":"query GetLicensedApplications {\n  licensedApplications\n    @rest(\n      type: \"LicensedApplication\"\n      endpoint: \"frameworkAPI\"\n      path: \"/configuration/applications\"\n    ) {\n    applicationId\n    name\n    hasLicense\n    valid\n  }\n}\n\nquery GetApplicationConfiguration($application: String) {\n  configuration(application: $application)\n    @rest(\n      type: \"Configuration\"\n      endpoint: \"frameworkAPI\"\n      path: \"/configuration?application={args.application}\"\n    ) {\n    configuration\n  }\n}\n\nquery GetCoursesConfiguration {\n  coursesConfiguration\n    @rest(\n      type: \"CoursesConfiguration\"\n      endpoint: \"workshopAPI\"\n      path: \"/portfoliooptions\"\n    ) {\n    enableECourses\n    enableCampusCourses\n    enableDoubleRegistration\n    pauseRegistration\n    reportingMonth\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["GetLicensedApplications"] = oneQuery(doc, "GetLicensedApplications");
        
        module.exports["GetApplicationConfiguration"] = oneQuery(doc, "GetApplicationConfiguration");
        
        module.exports["GetCoursesConfiguration"] = oneQuery(doc, "GetCoursesConfiguration");
        
